export default __webpack_public_path__ + "static/media/icon.5f7ba868.png";